module.exports = "//a.spikex.com/sigma/frontend-ssr-web-index/_next/static/images/banner-96232ecd4a9beb1eadf27dda54d6a94d.png";